<template>
    <a-modal title="" :width="'70%'" :open="$store.state.indexPop.visible" @cancel="cancel" :maskClosable="false"
        :footer="null" :bodyStyle="{ padding: '0', maxHeight: '75vh', overflowY: 'auto' }"
        class="performance-todo-modal" centered>
        <!-- ============================================================ -->
        <!-- 1. 顶部 -->
        <!-- ============================================================ -->
        <div class="modal-header">
            <div class="header-left">
                <div class="avatar-wrapper">
                    <a-avatar :size="48" style="background: #667eea; vertical-align: middle">
                        {{ userInitial }}
                    </a-avatar>
                    <span class="online-dot"></span>
                </div>
                <div class="greeting">
                    <div class="greeting-text">
                        欢迎回来，{{ admin_info.nickname }} 👋
                        <span class="sub-greeting">工单待办提醒</span>
                    </div>
                    <div class="header-meta">
                        <span class="dept-tag">🏢 <a v-for="value in admin_info.role_names">{{ value }}</a></span>
                        <span class="divider">|</span>
                        <span class="date-time">{{ currentDateTime }}</span>
                    </div>
                </div>
            </div>
            <div class="header-right">
                <div class="health-score">
                    <span class="score-label">代理合规指数</span>
                    <span class="score-value" :class="scoreStatus">{{ complianceScore }}</span>
                    <a-tooltip title="基于工单超时率、资料完整度综合评估">
                        <QuestionCircleOutlined style="color: #bfbfbf; margin-left: 4px" />
                    </a-tooltip>
                </div>
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- 2. 统计看板 -->
        <!-- ============================================================ -->
        <div class="stats-row">
            <div class="stat-card" :class="{ active: filterType === 'all' }" @click="filterType = 'all'">
                <div class="stat-num">{{ totalCount }}</div>
                <div class="stat-label">📋 全部待办</div>
            </div>
            <div class="stat-card" :class="{ active: filterType === 'urgent' }" @click="filterType = 'urgent'">
                <div class="stat-num urgent">{{ urgentCount }}</div>
                <div class="stat-label">⏳ 即将到期</div>
                <div class="stat-trend">近3天需处理</div>
            </div>
            <div class="stat-card" :class="{ active: filterType === 'files' }" @click="filterType = 'files'">
                <div class="stat-num files">{{ missingFilesList.length }}</div>
                <div class="stat-label">📎 待补充资料</div>
                <div class="stat-trend danger">逾期扣款中</div>
            </div>
            <div class="stat-card" :class="{ active: filterType === 'payment' }" @click="filterType = 'payment'">
                <div class="stat-num payment">{{ periodList.length }}</div>
                <div class="stat-label">💳 超期待付款</div>
                <div class="stat-trend">需尽快支付</div>
            </div>
            <div class="stat-card" :class="{ active: filterType === 'setup' }" @click="filterType = 'setup'">
                <div class="stat-num setup">{{ unfinishList.length }}</div>
                <div class="stat-label">📌 未办结设立</div>
                <div class="stat-trend">待办理事项</div>
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- 3. 筛选工具栏 -->
        <!-- ============================================================ -->
        <div class="toolbar">
            <div class="filter-tabs">
                <a-radio-group v-model:value="filterType" button-style="solid" size="small">
                    <a-radio-button value="all">全部</a-radio-button>
                    <a-radio-button value="work">工单</a-radio-button>
                    <a-radio-button value="files">资料</a-radio-button>
                    <a-radio-button value="payment">付款</a-radio-button>
                    <a-radio-button value="setup">设立</a-radio-button>
                </a-radio-group>
            </div>
            <div class="toolbar-right">
                <a-input-search placeholder="搜索待办标题" size="small" style="width: 200px" v-model:value="searchKeyword" />
                <a-button type="link" size="small" @click="handleExport">📤 导出待办</a-button>
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- 4. 待办列表 -->
        <!-- ============================================================ -->
        <div class="todo-list-wrapper">

            <!-- ========================================================== -->
            <!-- 板块1：未办结工单 -->
            <!-- ========================================================== -->
            <div class="todo-section">
                <div class="section-header" @click="toggleCollapse('work')">
                    <div class="section-title">
                        <span class="title-icon">📋</span> 未办结工单
                        <a-tag color="blue" class="count-tag">{{ filteredWorkList.length }}</a-tag>
                    </div>
                    <span class="collapse-icon">{{ collapseState.work ? '▾' : '▸' }}</span>
                </div>
                <div class="todo-items" v-if="collapseState.work">
                    <div v-for="(item, index) in processedWorkList" :key="'work-' + item.id" class="todo-item"
                        :class="item.priorityClass">
                        <div class="item-left">
                            <div class="item-index">{{ index + 1 }}</div>
                            <div class="item-content">
                                <div class="item-title">
                                    <span class="title-text">{{ item.title }}</span>
                                    <span v-if="item.critical_situation == 1" class="urgent-badge">不急</span>
                                    <span v-if="item.critical_situation == 2" class="urgent-badge">普通</span>
                                    <span v-if="item.critical_situation == 3" class="urgent-badge">紧急</span>
                                    <span v-if="item.critical_situation == 4" class="urgent-badge">最高级</span>
                                    <span class="meta-status" :class="item.statusClass">{{ item.statusText }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-agent" v-if="item.customer_info">👤 {{ item.customer_info.fddbr
                                    }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-entry">📥 录入：{{ item.created_at }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-deadline">⏰ 截止：{{ item.end_time }}</span>
                                    <span class="countdown" :class="item.countdownClass">({{ item.countdownText
                                        }})</span>
                                    <span class="meta-divider">|</span>
                                    <a-tag :color="getCategoryColor(item.category)" class="category-tag">{{
                                        item.category }}</a-tag>
                                    <span class="penalty-inline" v-if="item.overdueDays > 0">
                                        🚨 已超期 <strong>{{ item.overdueDays }}</strong> 天<span
                                            v-if="item.penalty > 0">，扣款 <strong class="penalty-amount">¥{{ item.penalty
                                                }}</strong></span>
                                    </span>
                                </div>
                                <div class="item-meta" v-if="item.customer_info">
                                    <span class="meta-entity">🏛️ 关联主体：{{ item.customer_info.full_name }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-address">📍 入驻地址：{{ item.customer_info.address_number }}</span>
                                    <span class="meta-divider">|</span>
                                </div>
                                <div class="item-meta">
                                    是否参与扣款:
                                    <p v-if="item.is_deduction == 1">
                                        <a-tag color="red">参与</a-tag>
                                        不理截止扣款时间：{{ item.first_deduction_time }}
                                    </p>
                                    <p v-else>
                                        <a-tag color="blue">不参与</a-tag>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="item-right">
                            <a-button type="primary" size="small" @click.stop="handleGoWorkOrder(item)">去处理</a-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================== -->
            <!-- 板块2：待补充资料 - 修复版 -->
            <!-- ========================================================== -->
            <div class="todo-section files-section">
                <div class="section-header" @click="toggleCollapse('files')">
                    <div class="section-title">
                        <span class="title-icon">📎</span> 待补充资料（合同 / 营业执照）30天开始提醒，45天开始扣款，1天1元，扣满100元停止扣款
                        <a-tag color="purple" class="count-tag">{{ filteredMissingFilesList.length }}</a-tag>
                    </div>
                    <span class="collapse-icon">{{ collapseState.files ? '▾' : '▸' }}</span>
                </div>
                <div class="todo-items" v-if="collapseState.files">
                    <div v-for="(item, index) in processedMissingFilesList" :key="'file-' + item.id"
                        class="todo-item file-item">
                        <div class="item-left">
                            <div class="item-index">{{ index + 1 }}</div>
                            <div class="item-content">
                                <div class="item-meta one-line">
                                    <!-- 主体名称 -->
                                    <span class="meta-title">{{ item.full_name }}</span>
                                    <!-- 扣款信息 -->
                                    <span class="penalty-inline" v-if="item.overdueDays > 0">
                                        🚨 已超期 <strong>{{ item.overdueDays }}</strong> 天，扣款 <strong
                                            class="penalty-amount">¥{{ item.penalty }}</strong>
                                    </span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-time">🕐 录入：{{ formatDate(item.created_at) }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-cert">📄 续费联系人：{{ item.xftel }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-expiry" v-if="item.koukuan">⏳ 到期未上传扣款截止日期：{{ item.koukuan.end_time
                                        }}</span>
                                    <span class="meta-divider">|</span>

                                    <!-- ======================================== -->
                                    <!-- 文件上传区域 - 每个文件类型独立 -->
                                    <!-- ======================================== -->
                                    <span class="upload-inline">
                                        <!-- 如果有 missing_files，遍历显示 -->
                                        <template v-for="(fileType, fileIndex) in item.missing_files" :key="fileIndex">
                                            <span class="file-icon" v-if="fileType === '营业执照'">📄</span>
                                            <span class="file-icon" v-else-if="fileType === '租赁合同'">📋</span>
                                            <span class="file-icon" v-else>📎</span>

                                            <span class="file-label">{{ fileType }}</span>

                                            <a-button size="small" type="primary" ghost class="upload-btn"
                                                :loading="isUploading(item.id, fileType)"
                                                @click.stop="triggerUploadById(item.id, fileType)">
                                                {{ isUploading(item.id, fileType) ? '上传中' : '上传' }}
                                            </a-button>
                                            <input type="file" :id="`file-upload-${item.id}-${fileType}`"
                                                style="display:none" accept=".pdf,.doc,.docx,.jpg,.png,.jpeg"
                                                @change="handleFileChange($event, item, fileType)" />

                                            <a-tag v-if="item.uploadedFiles && item.uploadedFiles.includes(fileType)"
                                                color="green" size="small">已传</a-tag>

                                            <span class="upload-divider"
                                                v-if="fileIndex < item.missing_files.length - 1">|</span>
                                        </template>

                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================== -->
            <!-- 板块3：超期待付款单 -->
            <!-- ========================================================== -->
            <div class="todo-section">
                <div class="section-header" @click="toggleCollapse('payment')">
                    <div class="section-title">
                        <span class="title-icon">💰</span> 超期待付款单
                        <a-tag color="orange" class="count-tag">{{ filteredPeriodList.length }}</a-tag>
                    </div>
                    <span class="collapse-icon">{{ collapseState.payment ? '▾' : '▸' }}</span>
                </div>
                <div class="todo-items" v-if="collapseState.payment">
                    <div v-for="(item, index) in filteredPeriodList" :key="'period-' + index" class="todo-item">
                        <div class="item-left">
                            <div class="item-index">{{ index + 1 }}</div>
                            <div class="item-content">
                                <div class="item-meta one-line">
                                    <span class="meta-title">{{ item.full_name }}</span>
                                    <span class="unpaid-badge">未付款</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-phone" @click="onCopyClick(item.xftel)">
                                        <CopyOutlined class="copy-icon" />
                                        {{ item.xftel }}
                                    </span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-time">🕐 录入：{{ formatDate(item.created_at) }}</span>
                                    <span class="meta-divider">|</span>
                                    <a-tag :color="item.is_ybr == 1 ? 'blue' : 'green'" class="category-tag">{{
                                        item.tax_type == 1 ? '一般纳税人' : '小规模纳税人' }}</a-tag>
                                    <span class="meta-divider">|</span>
                                    <a-tag :color="item.registration_type == 1 ? 'purple' : 'cyan'"
                                        class="category-tag">{{
                                            item.registration_type == 1 ? '包注册' : '出裸地址' }}</a-tag>
                                    <span class="meta-divider">|</span>
                                    <a-tag :color="item.business_type == 1 ? 'green' : 'orange'" class="category-tag">{{
                                        item.business_type == 1 ? '设立' : '迁入' }}</a-tag>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-address">📍 {{ item.address_number }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item-right">
                            <a-button type="primary" danger size="small" class="pay-btn"
                                @click.stop="handlePay(item.id)">立即付款</a-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ========================================================== -->
            <!-- 板块4：未办结设立或迁入 -->
            <!-- ========================================================== -->
            <div class="todo-section setup-section">
                <div class="section-header" @click="toggleCollapse('setup')">
                    <div class="section-title">
                        <span class="title-icon">📌</span> 未办结设立或迁入
                        <a-tag color="cyan" class="count-tag">{{ filteredSetupList.length }}</a-tag>
                    </div>
                    <span class="collapse-icon">{{ collapseState.setup ? '▾' : '▸' }}</span>
                </div>
                <div class="todo-items" v-if="collapseState.setup">
                    <div v-for="(item, index) in filteredSetupList" :key="'setup-' + index"
                        class="todo-item setup-item">
                        <div class="item-left">
                            <div class="item-index">{{ index + 1 }}</div>
                            <div class="item-content">
                                <div class="item-meta one-line">
                                    <span class="meta-title">{{ item.full_name }}</span>
                                    <span class="setup-badge">待办理</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-time">📅 创建：{{ formatDate(item.created_at) }}</span>
                                    <span class="meta-divider">|</span>
                                    <span class="meta-remind">💬 {{ item.remind || '请及时办理设立或迁入手续或办结本次申请' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="item-right">
                            <a-button type="primary" size="small" @click.stop="handleGoNewTab(item)">去处理</a-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 空状态 -->
            <div v-if="isEmpty" class="empty-state">
                <a-empty description="🎉 太棒了！当前没有匹配的待办事项" />
            </div>
        </div>

        <!-- ============================================================ -->
        <!-- 5. 底部操作栏 -->
        <!-- ============================================================ -->
        <div class="modal-footer">
            <div class="footer-left">
                <span class="footer-tip">💡 超期工单及资料将产生违约金，请尽快处理</span>
            </div>
            <div class="footer-right">
                <a-button @click="cancel">稍后处理</a-button>
                <a-button type="primary" @click="handleModalOk">我知道了</a-button>
            </div>
        </div>
        <!-- 直接付款 -->
        <direct-payment v-if="payData.visiblePay" @cancel="handleCancel" @ok="handleOk"
            :tableColumnsData="payData.custData"></direct-payment>
    </a-modal>
</template>

<script lang="ts" setup>
import { message } from 'ant-design-vue'
import { reactive, onMounted, ref, computed } from 'vue'
import { useStore } from 'vuex'
import { QuestionCircleOutlined, CopyOutlined } from '@ant-design/icons-vue'
import { useRouter } from 'vue-router'
import baseService from '@/utils/http/axios'
import DirectPayment from '../../views/customer/components/DirectPayment.vue'
const router = useRouter()
const $store = useStore()
const emit = defineEmits(['cancel', 'ok'])

// ================================================================
// 折叠状态
// ================================================================
const collapseState = reactive({
    work: true,
    files: true,
    payment: false,
    setup: false
})

const toggleCollapse = (key: string) => {
    collapseState[key] = !collapseState[key]
}

// ================================================================
// 状态
// ================================================================
const filterType = ref<'all' | 'work' | 'files' | 'payment' | 'setup' | 'urgent'>('all')
const searchKeyword = ref('')

// ================================================================
// 上传状态管理 - 使用独立的响应式对象
// ================================================================
const uploadingMap = ref<Record<string, boolean>>({})

// 获取上传状态的 key
const getUploadKey = (itemId: number | string, fileType: string) => {
    return `${itemId}-${fileType}`
}

// 检查是否正在上传
const isUploading = (itemId: number | string, fileType: string) => {
    const key = getUploadKey(itemId, fileType)
    return !!uploadingMap.value[key]
}

// 设置上传状态
const setUploading = (itemId: number | string, fileType: string, status: boolean) => {
    const key = getUploadKey(itemId, fileType)
    if (status) {
        uploadingMap.value[key] = true
    } else {
        delete uploadingMap.value[key]
    }
}

// ================================================================
// 工具函数
// ================================================================
const getDaysDiff = (dateStr: string) => {
    if (!dateStr) return 999
    const target = new Date(dateStr)
    const now = new Date()
    target.setHours(0, 0, 0, 0)
    now.setHours(0, 0, 0, 0)
    return Math.ceil((target.getTime() - now.getTime()) / (1000 * 60 * 60 * 24))
}

const formatDate = (dateStr: string) => {
    if (!dateStr) return '-'
    const d = new Date(dateStr)
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
}

const getOverdueDays = (dateStr: string) => {
    if (!dateStr) return 0
    const target = new Date(dateStr)
    const now = new Date()
    target.setHours(0, 0, 0, 0)
    now.setHours(0, 0, 0, 0)
    return Math.max(0, Math.ceil((now.getTime() - target.getTime()) / (1000 * 60 * 60 * 24)))
}

const getPenalty = (dateStr: string) => {
    const days = getOverdueDays(dateStr)
    if (days <= 0) return 0
    return 20 + (days - 1) * 5
}

const getStatusClass = (daysDiff: number) => {
    if (daysDiff < 0) return 'error'
    if (daysDiff <= 2) return 'warning'
    return 'processing'
}
const getStatusText = (daysDiff: number) => {
    if (daysDiff < 0) return '已超期'
    if (daysDiff <= 2) return '即将到期'
    return '处理中'
}
const getPriorityClass = (daysDiff: number) => {
    if (daysDiff < 0) return 'priority-overdue'
    if (daysDiff <= 2) return 'priority-urgent'
    return ''
}
const getCountdownText = (daysDiff: number) => {
    if (daysDiff < 0) return `已超期 ${Math.abs(daysDiff)} 天`
    if (daysDiff === 0) return '今天到期'
    return `${daysDiff} 天后到期`
}
const getCountdownClass = (daysDiff: number) => {
    if (daysDiff < 0) return 'overdue'
    if (daysDiff <= 2) return 'urgent'
    return ''
}

const getCategoryName = (type: number) => {
    const map: Record<number, string> = { 1: '投诉', 2: '举报', 3: '代办事项', 4: '信函' }
    return map[type] || 'default'
}
const getCategoryColor = (category: string) => {
    const map: Record<string, string> = { '投诉': 'red', '举报': 'orange', '代办事项': 'blue' }
    return map[category] || '其他'
}

// ================================================================
// 数据获取
// ================================================================
const popupData = computed(() => $store.state.indexPop.popupData || {
    admin_info: {},
    workOrder_list: [],
    period_list: [],
    unfinish_list: [],
    missing_files_list: []
})
const admin_info = computed(() => popupData.value.admin_info || {})

const workList = computed(() => popupData.value.workOrder_list || [])
const periodList = computed(() => popupData.value.period_list || [])
const unfinishList = computed(() => popupData.value.unfinish_list || [])
const missingFilesList = computed(() => popupData.value.missing_files_list || [])

// ================================================================
// 预处理
// ================================================================
const userInitial = computed(() => {
    const nickname = admin_info.value.nickname || ''
    return nickname.charAt(0) || '用'
})

const processedWorkList = computed(() => {
    return filteredWorkList.value.map((item: any) => {
        const daysDiff = getDaysDiff(item.end_time)
        const overdueDays = getOverdueDays(item.end_time)
        const category = getCategoryName(item.type)
        return {
            ...item,
            daysDiff,
            overdueDays,
            category,
            statusClass: getStatusClass(daysDiff),
            statusText: getStatusText(daysDiff),
            priorityClass: getPriorityClass(daysDiff),
            countdownText: getCountdownText(daysDiff),
            countdownClass: getCountdownClass(daysDiff)
        }
    })
})

const processedMissingFilesList = computed(() => {
    return filteredMissingFilesList.value.map((item: any) => {
        const overdueDays = getOverdueDays(item.expiry_date)
        return {
            ...item,
            overdueDays,
            uploadedFiles: item.uploadedFiles || [],
            missing_files: item.missing_files || ['营业执照', '租赁合同']
        }
    })
})

// ================================================================
// 计算属性
// ================================================================
const totalCount = computed(() => workList.value.length + periodList.value.length + unfinishList.value.length + missingFilesList.value.length)

const urgentCount = computed(() => {
    return workList.value.filter((item: any) => {
        if (!item.end_time) return false
        const diff = getDaysDiff(item.end_time)
        return diff >= 0 && diff <= 3
    }).length
})

const complianceScore = computed(() => {
    const base = 100
    const urgentPenalty = urgentCount.value * 1
    const overdueWorkCount = workList.value.filter((item: any) => getOverdueDays(item.end_time) > 0).length
    const overdueFileCount = missingFilesList.value.filter((item: any) => getOverdueDays(item.expiry_date) > 0).length
    const filePenalty = (overdueWorkCount + overdueFileCount) * 3
    return Math.max(40, base - urgentPenalty - filePenalty)
})

const scoreStatus = computed(() => {
    const s = complianceScore.value
    if (s >= 85) return 'high'
    if (s >= 65) return 'mid'
    return 'low'
})

const currentDateTime = computed(() => {
    const now = new Date()
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`
})

// ================================================================
// 过滤逻辑
// ================================================================
const filteredWorkList = computed(() => {
    if (filterType.value === 'files' || filterType.value === 'payment' || filterType.value === 'setup') return []
    let list = workList.value
    if (filterType.value === 'urgent') {
        list = list.filter((item: any) => {
            if (!item.end_time) return false
            const diff = getDaysDiff(item.end_time)
            return diff >= 0 && diff <= 3
        })
    }
    if (searchKeyword.value) {
        list = list.filter((item: any) => item.title?.includes(searchKeyword.value))
    }
    return list
})

const filteredMissingFilesList = computed(() => {
    if (filterType.value === 'work' || filterType.value === 'payment' || filterType.value === 'setup' || filterType.value === 'urgent') return []
    if (filterType.value === 'all' || filterType.value === 'files') {
        let list = missingFilesList.value
        if (searchKeyword.value) {
            list = list.filter((item: any) =>
                (item.full_name || item.name)?.includes(searchKeyword.value)
            )
        }
        return list
    }
    return []
})

const filteredPeriodList = computed(() => {
    if (filterType.value === 'files' || filterType.value === 'work' || filterType.value === 'setup' || filterType.value === 'urgent') return []
    if (filterType.value === 'all' || filterType.value === 'payment') {
        let list = periodList.value
        if (searchKeyword.value) {
            list = list.filter((item: any) => item.full_name?.includes(searchKeyword.value))
        }
        return list
    }
    return []
})

const filteredSetupList = computed(() => {
    if (filterType.value === 'work' || filterType.value === 'payment' || filterType.value === 'files' || filterType.value === 'urgent') return []
    if (filterType.value === 'all' || filterType.value === 'setup') {
        let list = unfinishList.value
        if (searchKeyword.value) {
            list = list.filter((item: any) => item.full_name?.includes(searchKeyword.value))
        }
        return list
    }
    return []
})

const isEmpty = computed(() => {
    return filteredWorkList.value.length === 0 &&
        filteredMissingFilesList.value.length === 0 &&
        filteredPeriodList.value.length === 0 &&
        filteredSetupList.value.length === 0
})

// ================================================================
// 文件上传 - 通过唯一 ID 触发
// ================================================================
const triggerUploadById = (itemId: number | string, fileType: string) => {
    const inputId = `file-upload-${itemId}-${fileType}`
    const input = document.getElementById(inputId) as HTMLInputElement
    if (input) {
        input.click()
    } else {
        console.warn('未找到文件输入框:', inputId)
    }
}

// ================================================================
// 处理文件上传
// ================================================================
const handleFileChange = async (event: Event, item: any, fileType: string) => {
    const input = event.target as HTMLInputElement
    if (!input.files || input.files.length === 0) return
    const file = input.files[0]

    // 验证文件大小（限制 10MB）
    if (file.size > 10 * 1024 * 1024) {
        message.error(`${fileType} 文件大小不能超过 10MB`)
        input.value = ''
        return
    }

    // 验证文件类型
    const validExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']
    const fileExt = '.' + file.name.split('.').pop()?.toLowerCase()
    if (!validExtensions.includes(fileExt)) {
        message.error('请上传 PDF、Word、JPG 或 PNG 格式的文件')
        input.value = ''
        return
    }
    if (!item.upload_path) {
        message.error('上传失败，未找到上传路径')
        return
    }

    // 设置上传状态 - 按钮显示 loading
    setUploading(item.id, fileType, true)

    try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('upload_path', btoa(encodeURIComponent(item.upload_path)))
        const response = await baseService.post('/admin/v1/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        let typeArr = { '营业执照': 8, '租赁合同': 4 }
        let type = typeArr[fileType] ?? null
        if (!type) {
            message.error('上传失败，未找到文件类型')
            return
        }
        let createForm = {
            'type': type,
            'url': [{
                'url': response.data.url,
                'name': file.name
            }],
            'remark': 'pop文件上传'
        }
        let requestParam = {
            url: '/admin/v1//templateZipAppend',
            method: 'post',
            data: Object.assign({ customer_id: item.id }, createForm)
        }
        const response2 = await baseService(requestParam)

        // 更新上传状态
        if (!item.uploadedFiles) {
            item.uploadedFiles = []
        }
        if (!item.uploadedFiles.includes(fileType)) {
            item.uploadedFiles.push(fileType)
        }

        message.success({ content: `${fileType} 上传成功！`, key: 'upload', duration: 2 })
    } catch (error) {
        message.error({ content: `${fileType} 上传失败，请重试`, key: 'upload', duration: 2 })
        console.error('Upload error:', error)
    } finally {
        // 清除上传状态 - 按钮恢复正常
        setUploading(item.id, fileType, false)
        // 重置 input 以便重复上传同一文件
        input.value = ''
    }
}

// ================================================================
// 事件处理
// ================================================================
const cancel = () => $store.dispatch('indexPop/closePopup')
const handleModalOk = () => $store.dispatch('indexPop/closePopup')
const handleGoWorkOrder = (item: any) => {
    message.success(`正在跳转: ${item.title || item.full_name}`)
    cancel()
    router.push({ path: '/workOrder', query: { title: item.title } })
}
const handleGoNewTab = (item: any) => {
    message.success(`正在跳转: ${item.title || item.full_name}`)
    cancel()
    //这个没有起作用，要用别的技术通信
    router.push({ path: '/customer', query: { customer_name: item.full_name, tabsKey: 2 } })
}
const payData = reactive({
    visiblePay: false,
    custData: {}
})
const handlePay = (customer_id) => {
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 1, breakAdmin: 1 }, { customer_id: customer_id })
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data.list.length > 0) {
                payData.custData = res.data.list[0]
                payData.visiblePay = true
            } else {
                message.error('未查询到客户信息')
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
        })
}
const handleExport = () => message.success('正在导出待办清单...')

const onCopyClick = (str) => {
    var input = document.createElement('input')
    //将input的值设置为需要复制的内容
    input.value = String(str)
    //添加input标签
    document.body.appendChild(input)
    //选中input标签
    input.select()
    //执行复制
    document.execCommand('copy')
    //成功提示信息
    message.success('复制成功！')
    //移除input标签
    document.body.removeChild(input)
}
const handleOk = () => {
    payData.visiblePay = false
}
const handleCancel = () => {
    payData.visiblePay = false
}

onMounted(() => { })
</script>

<style lang="less" scoped>
// ================================================================
// 全局样式
// ================================================================
.performance-todo-modal {
    :deep(.ant-modal-content) {
        border-radius: 20px;
        overflow: hidden;
        box-shadow: 0 24px 80px rgba(0, 0, 0, 0.18);
    }

    :deep(.ant-modal-body) {
        padding: 0;
    }

    :deep(.ant-modal-body::-webkit-scrollbar) {
        width: 4px;
    }

    :deep(.ant-modal-body::-webkit-scrollbar-thumb) {
        background: #d9d9d9;
        border-radius: 4px;
    }
}

// ================================================================
// 头部
// ================================================================
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px 20px;
    background: linear-gradient(135deg, #f5f7ff 0%, #ffffff 100%);
    border-bottom: 1px solid #f0f0f0;

    .header-left {
        display: flex;
        align-items: center;
        gap: 16px;

        .avatar-wrapper {
            position: relative;

            .online-dot {
                position: absolute;
                bottom: 2px;
                right: 2px;
                width: 12px;
                height: 12px;
                background: #52c41a;
                border-radius: 50%;
                border: 2px solid #fff;
            }
        }

        .greeting {
            .greeting-text {
                font-size: 18px;
                font-weight: 600;
                color: #1a1a2e;

                .sub-greeting {
                    font-weight: 400;
                    font-size: 14px;
                    color: #8c8c8c;
                    margin-left: 8px;
                }
            }

            .header-meta {
                margin-top: 2px;
                font-size: 13px;
                color: #8c8c8c;

                .dept-tag {
                    background: #e6f7ff;
                    color: #1890ff;
                    padding: 0 8px;
                    border-radius: 4px;
                }

                .divider {
                    margin: 0 8px;
                }
            }
        }
    }

    .header-right {
        .health-score {
            background: #fff;
            padding: 6px 18px 6px 16px;
            border-radius: 30px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            border: 1px solid #f0f0f0;

            .score-label {
                font-size: 13px;
                color: #8c8c8c;
                margin-right: 8px;
            }

            .score-value {
                font-size: 20px;
                font-weight: 700;

                &.high {
                    color: #52c41a;
                }

                &.mid {
                    color: #faad14;
                }

                &.low {
                    color: #ff4d4f;
                }
            }
        }
    }
}

// ================================================================
// 统计看板
// ================================================================
.stats-row {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    padding: 20px 32px;
    background: #fafafa;
    border-bottom: 1px solid #f0f0f0;

    .stat-card {
        background: #fff;
        border-radius: 14px;
        padding: 16px 20px;
        cursor: pointer;
        transition: all 0.25s ease;
        border: 2px solid transparent;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.02);

        &:hover {
            transform: translateY(-3px);
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
        }

        &.active {
            border-color: #667eea;
            background: #f8f9ff;
        }

        .stat-num {
            font-size: 28px;
            font-weight: 700;
            color: #1a1a2e;
            line-height: 1.2;

            &.urgent {
                color: #fa8c16;
            }

            &.files {
                color: #722ed1;
            }

            &.payment {
                color: #1890ff;
            }

            &.setup {
                color: #13c2c2;
            }
        }

        .stat-label {
            font-size: 14px;
            color: #4a4a5a;
            margin-top: 2px;
        }

        .stat-trend {
            font-size: 12px;
            color: #8c8c8c;
            margin-top: 4px;

            &.danger {
                color: #ff4d4f;
                font-weight: 500;
            }
        }
    }
}

// ================================================================
// 工具栏
// ================================================================
.toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 32px;
    background: #ffffff;
    border-bottom: 1px solid #f0f0f0;

    .filter-tabs {
        :deep(.ant-radio-group) {
            .ant-radio-button-wrapper {
                height: 28px;
                line-height: 26px;
                padding: 0 14px;
            }
        }
    }

    .toolbar-right {
        display: flex;
        align-items: center;
        gap: 12px;
    }
}

// ================================================================
// 待办列表
// ================================================================
.todo-list-wrapper {
    padding: 16px 32px 8px;
}

.todo-section {
    margin-bottom: 12px;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);

    .section-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        cursor: pointer;
        user-select: none;
        border-radius: 12px;

        .section-title {
            font-size: 15px;
            font-weight: 600;
            color: #1a1a2e;
            display: flex;
            align-items: center;
            gap: 8px;

            .title-icon {
                font-size: 18px;
            }

            .count-tag {
                font-weight: 500;
            }
        }

        .collapse-icon {
            font-size: 16px;
            color: #8c8c8c;
            margin-left: 12px;
        }
    }

    .todo-items {
        padding: 0 16px 12px 16px;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    &.files-section {
        .section-header .section-title {
            color: #722ed1;
        }

        .todo-item.file-item {
            border-left-color: #722ed1;
            background: #f9f0ff;
        }
    }

    &.setup-section {
        .section-header .section-title {
            color: #13c2c2;
        }

        .todo-item.setup-item {
            border-left-color: #13c2c2;
            background: #f0faff;
        }
    }
}

// ================================================================
// 待办项
// ================================================================
.todo-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 14px;
    background: #fafbfc;
    border-radius: 10px;
    border-left: 4px solid transparent;

    &.priority-urgent {
        border-left-color: #faad14;
        background: #fffbe6;
    }

    &.priority-overdue {
        border-left-color: #ff4d4f;
        background: #fff1f0;
    }

    &.file-item {
        border-left-color: #722ed1;
        background: #f9f0ff;
    }

    &.setup-item {
        border-left-color: #13c2c2;
        background: #f0faff;
    }

    .item-left {
        display: flex;
        align-items: center;
        gap: 12px;
        flex: 1;
        min-width: 0;

        .item-index {
            width: 20px;
            height: 20px;
            background: #e8e8e8;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            color: #8c8c8c;
            flex-shrink: 0;
        }

        .item-content {
            flex: 1;
            min-width: 0;

            .item-title {
                font-size: 13px;
                font-weight: 500;
                color: #1a1a2e;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 4px 6px;
                line-height: 1.6;

                .title-text {
                    font-weight: 600;
                }

                .urgent-badge {
                    background: #ff4d4f;
                    color: #fff;
                    font-size: 10px;
                    padding: 0 8px;
                    border-radius: 10px;
                    font-weight: 500;
                }

                .meta-status {
                    padding: 0 8px;
                    border-radius: 10px;
                    font-size: 10px;
                    font-weight: 500;

                    &.warning {
                        background: #fff7e6;
                        color: #fa8c16;
                    }

                    &.error {
                        background: #fff1f0;
                        color: #ff4d4f;
                    }

                    &.processing {
                        background: #e6f7ff;
                        color: #1890ff;
                    }
                }

                .meta-divider {
                    color: #d9d9d9;
                }

                .meta-agent,
                .meta-deadline,
                .meta-start,
                .meta-entry {
                    color: #4a4a5a;
                    font-size: 12px;
                    font-weight: 400;
                }

                .meta-deadline {
                    font-weight: 500;
                }

                .countdown {
                    font-weight: 500;
                    font-size: 10px;

                    &.urgent {
                        color: #fa8c16;
                    }

                    &.overdue {
                        color: #ff4d4f;
                    }
                }

                .category-tag {
                    font-size: 10px;
                    margin: 0;
                    padding: 0 6px;
                    line-height: 18px;
                }

                .penalty-inline {
                    font-size: 11px;
                    color: #ff4d4f;
                    margin-left: 4px;

                    strong {
                        font-weight: 700;
                        color: #ff4d4f;
                    }

                    .penalty-amount {
                        font-size: 13px;
                        color: #ff4d4f;
                    }
                }
            }

            .item-meta {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 3px 8px;
                margin-top: 1px;
                font-size: 12px;
                color: #8c8c8c;

                .meta-divider {
                    color: #d9d9d9;
                }

                .meta-entity,
                .meta-address {
                    color: #4a4a5a;
                }

                .meta-tags-label {
                    color: #4a4a5a;
                }

                .tag-item {
                    font-size: 10px;
                    margin: 0 1px;
                    padding: 0 6px;
                    line-height: 16px;
                }

                .category-tag {
                    font-size: 10px;
                    margin: 0;
                    padding: 0 6px;
                    line-height: 18px;
                }

                &.one-line {
                    gap: 4px 8px;
                    flex-wrap: wrap;

                    .meta-title {
                        font-weight: 600;
                        color: #1a1a2e;
                    }

                    .penalty-inline {
                        font-size: 11px;
                        color: #ff4d4f;
                        margin-left: 4px;

                        strong {
                            font-weight: 700;
                            color: #ff4d4f;
                        }

                        .penalty-amount {
                            font-size: 13px;
                            color: #ff4d4f;
                        }
                    }
                }

                .upload-inline {
                    display: inline-flex;
                    align-items: center;
                    gap: 4px;
                    flex-wrap: wrap;

                    .file-icon {
                        font-size: 14px;
                    }

                    .file-label {
                        font-size: 12px;
                        color: #4a4a5a;
                        font-weight: 500;
                    }

                    .upload-divider {
                        color: #d9d9d9;
                    }

                    :deep(.ant-btn-sm) {
                        height: 22px;
                        font-size: 11px;
                        padding: 0 10px;
                        line-height: 20px;
                        min-width: 52px;
                    }

                    :deep(.ant-tag) {
                        font-size: 10px;
                        padding: 0 6px;
                        line-height: 16px;
                        margin: 0;
                    }
                }
            }

            .setup-badge {
                background: #13c2c2;
                color: #fff;
                font-size: 10px;
                padding: 0 8px;
                border-radius: 10px;
                font-weight: 500;
                display: inline-block;
                line-height: 20px;
            }

            .unpaid-badge {
                background: #ff4d4f;
                color: #fff;
                font-size: 10px;
                padding: 0 8px;
                border-radius: 10px;
                font-weight: 500;
                display: inline-block;
                line-height: 20px;
            }

            .copy-icon {
                font-size: 13px;
                color: #1890ff;
                cursor: pointer;
                margin-right: 2px;

                &:hover {
                    color: #40a9ff;
                }
            }
        }
    }

    .item-right {
        flex-shrink: 0;
        margin-left: 12px;

        :deep(.ant-btn-sm) {
            height: 26px;
            font-size: 12px;
            padding: 0 12px;
        }
    }
}

// ================================================================
// 上传按钮样式 - 修复按钮变白问题
// ================================================================
.upload-btn {
    min-width: 52px;
    transition: all 0.3s ease;
    color: #1890ff !important;
    background: #fff !important;
    border-color: #1890ff !important;

    &:hover {
        color: #40a9ff !important;
        background: #fff !important;
        border-color: #40a9ff !important;
    }

    // 上传中状态 - 保持按钮可见
    &.ant-btn-loading {
        color: #1890ff !important;
        background: #fff !important;
        border-color: #1890ff !important;
        opacity: 1 !important;

        .ant-btn-loading-icon {
            color: #1890ff !important;
        }
    }

    // 禁用状态
    &.ant-btn-disabled {
        color: #1890ff !important;
        background: #fff !important;
        border-color: #1890ff !important;
        opacity: 0.6 !important;
    }
}

// 强制覆盖 antd 的 loading 样式
:deep(.ant-btn.ant-btn-primary.ant-btn-background-ghost.ant-btn-loading) {
    color: #1890ff !important;
    background: #fff !important;
    border-color: #1890ff !important;
    opacity: 1 !important;

    .ant-btn-loading-icon {
        color: #1890ff !important;
    }
}

:deep(.ant-btn.ant-btn-primary.ant-btn-background-ghost) {
    color: #1890ff !important;
    background: #fff !important;
    border-color: #1890ff !important;

    &:hover {
        color: #40a9ff !important;
        background: #fff !important;
        border-color: #40a9ff !important;
    }
}

// ================================================================
// 空状态
// ================================================================
.empty-state {
    padding: 30px 0;
    text-align: center;
}

// ================================================================
// 底部
// ================================================================
.modal-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 32px 20px;
    border-top: 1px solid #f0f0f0;
    background: #fafbfc;

    .footer-left .footer-tip {
        color: #8c8c8c;
        font-size: 13px;
    }

    .footer-right {
        display: flex;
        gap: 12px;
    }
}

// ================================================================
// 按钮修复
// ================================================================
.pay-btn {
    &:hover {
        color: #fff !important;
        background: #ff4d4f !important;
        border-color: #ff4d4f !important;
    }
}
</style>
